import { COOKIELANG } from "@src/constants";
import { axiosModules } from "@qubit-utill/src";

export default {
  getCodeList: (codeGroup: string) => {
    return axiosModules.get(`/code/bycodegroup?codeGroup=${codeGroup}`, {
      lang: COOKIELANG,
    });
  },

  getCodeListByArr: (codeGroup) => {
    return axiosModules.get("/code/bycodegroups", {
      codeGroup,
      lang: COOKIELANG,
    });
  },

  getTimezones: () => {
    return axiosModules.get("/code/timezones");
  },

  getSearchMenus: (params) => {
    return axiosModules.get("/code/searchmenus", {
      ...params,
      lang: COOKIELANG,
    });
  },

  getLinkUrl: () => axiosModules.get(`/code/linkurl`),
};
